import { useEffect, useContext, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApiContext } from '../../contexts/ApiContext';
import { catalogPath, DEFAULT_CATALOG_SECTION } from '../../config/catalogSections';

/**
 * Buscador por modelo. Al elegir un resultado navega a la URL del producto
 * dentro de la sección actual, en lugar de mutar el estado del context.
 * El índice de /api/product-search ya trae brand_slug y slug de cada producto.
 */
export default function SearchInput({ section = DEFAULT_CATALOG_SECTION }) {

    const { productSearch } = useContext(ApiContext);
    const navigate = useNavigate();

    const [searchValue, setSearchValue] = useState('');
    const [filteredProducts, setFilteredProducts] = useState([]);

    const products = useMemo(() => (Array.isArray(productSearch) ? productSearch : []), [productSearch]);

    const handleInputChange = (event) => {
        setSearchValue(event.target.value);
    };

    const handleProductSearch = (product) => {
        setFilteredProducts([]);
        setSearchValue('');
        navigate(catalogPath(section, product.brand_slug, product.slug));
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            if (searchValue.trim().length < 3) {
                setFilteredProducts([]);
                return;
            }

            const needle = searchValue.replace(/\s/g, '').toLowerCase();
            setFilteredProducts(
                products.filter(product =>
                    product.nombre_producto.replace(/\s/g, '').toLowerCase().includes(needle)
                )
            );
        }, 150); // Añadir debounce de 150ms

        return () => clearTimeout(timer); // Limpia el timeout al desmontar

    }, [searchValue, products]);

    return (
        <div className="dropdown" style={{ width: '100%' }}>
            <input
                className='form-control'
                type="text"
                placeholder='Busque su Equipo'
                value={searchValue}
                onChange={handleInputChange}
            />
            {searchValue.length >= 3 && filteredProducts.length > 0 && (
                <ul className="list-group dropdown-menu show" style={{width: '100%'}}>
                    {filteredProducts.map(product => (
                        <li
                            key={product.id}
                            className="list-group-item list-group-item-action"
                            onClick={() => handleProductSearch(product)}
                        >
                            {product.nombre_producto}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};
